/**
 * Importação da classe genérica para requisições em serviços
 */
import GenericCrud from 'services/crud/GenericCrud';

/**
 * Importação da biblioteca axios para fazer requisições baseadas em Promises.
 */
import axios from 'axios';

export default class operators extends GenericCrud {
  constructor() {
    super('atributo-camada');
  }

  /**
   * Método para obtenção dos operadores de uma camada
   *
   * @param {string} workspace Nome da camada composto pelo workspace da camada
   * @param {string} layerName Nome da camada
   */
  async get(
    workspace,
    layerName
  ) {
    try {
      let params = {
        workspace: workspace,
        layer: layerName,
      };

      let attributes = await axios(
        `${process.env.REACT_APP_API_HOST}${this.apiVersion}${this.endPoint}`,
        { params }
      );

      if (attributes?.data?._embedded?.atributo_camada?.length > 0) {
        return {
          operators: attributes.data._embedded.atributo_camada,
        };
      } else {
        return { operators: [] };
      }
    } catch (error) {
      console.error(error);
    }
  }
}
